import React from 'react';

type DropdownOption = (string | React.ReactNode)[];

const Dropdown: React.FunctionComponent<{
  options: DropdownOption;
  defaultItemNull?: any;
  right?: boolean;
  disabled?: boolean;
  onClick?: (evt: any) => void;
}> = ({
  options = [],
  right,
  defaultItemNull = `Direct input`,
  disabled,
  onClick,
}) => {
  const [selectedOption, ...selectOptions] = options;
  return (
    <div className={right ? `dropdown dropdown-right` : `dropdown`}>
      <button
        className="btn btn-lg btn-block dropdown-toggle"
        tabIndex={0}
        disabled={disabled}
      >
        {selectedOption} <i className="icon icon-caret" />
      </button>
      <ul className="menu" onClick={onClick}>
        {selectOptions.map((opt, idx) => {
          if (opt === `|`) {
            return <li key={idx} className="divider" />;
          }
          if (typeof opt !== `string`) {
            return (
              <React.Fragment key={idx}>
                {opt || (
                  <li key={idx} className="menu-item">
                    <a>{defaultItemNull}</a>
                  </li>
                )}
              </React.Fragment>
            );
          }
          return (
            <li key={idx} className="menu-item">
              <a>{opt}</a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Dropdown;
